import { useEffect, useMemo } from "react";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const PowerMapPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: powerMapData = [] } = useGetProtectedApiDataQuery({
    url: "power_map",
    lang: languageType,
  });

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  // last updated on
  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(powerMapData);
  }, [powerMapData]);

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={getText("Power Generation", "विद्युत उत्पादन")}
        titleLink="/power-generation"
        levelTwo={true}
        titleTwo={innerBannerTitle}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div className="" style={{ overflowX: "hidden", width: "100%" }}>
        <div className="container" style={{ maxWidth: "100%" }}>
          <div className="row">
            <div className="col-12">
              <img
                src="/images/power-map-inner.jpg"
                alt={getText(
                  "Map of India with pointers showing the locations of NEEPCO power plants, including hydro power stations that are completed and under construction",
                  "भारत का मानचित्र, जिसमें नीपको के विद्युत संयंत्रों के स्थान दर्शाए गए हैं, जिनमें पूर्ण और निर्माणाधीन जल विद्युत स्टेशन शामिल हैं",
                )}
                style={{
                  width: "80%",
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>
          </div>
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        </div>
      </div>
    </>
  );
};

export default PowerMapPage;
